import { inject } from '@angular/core';
import { EnrolmentApiService, CourseLevelApiService, ClusterApiService } from '@shared/services';
import { PERMISSIONS } from '@shared/constants';
import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';
import { enrolmentFilterConfig } from '@shared/components/generic-filter-toolbar';

export const enrolmentTableConfig = (): TableConfig => {
    const enrolmentApiService = inject(EnrolmentApiService);
    const courseLevelApiService = inject(CourseLevelApiService);
    const clusterApiService = inject(ClusterApiService);

    return {
        title: 'Danh sách xếp lớp',
        entityName: 'enrolment',
        service: enrolmentApiService,
        method: 'searchEnrolments',
        usePostMethod: true,
        filterConfig: enrolmentFilterConfig(courseLevelApiService, clusterApiService),
        columns: [
            { field: 'learner', header: 'Học viên', width: 'min-w-[150px]', sortable: false, type: 'custom' },
            { field: 'ec', header: 'EC', width: 'min-w-[150px]', sortable: false, type: 'custom' },
            { field: 'courseLevel.name', header: 'Level', width: 'min-w-[100px]', sortable: true, type: 'tag', tagColor: 'courseLevel.tagColor', tagTextColor: 'courseLevel.tagTextColor' },
            { field: 'availableFrom', header: 'Từ ngày', width: 'min-w-[120px]', sortable: true, type: 'date', dateFormat: 'dd/MM/yyyy' },
            { field: 'deadline1', header: 'Deadline 1', width: 'min-w-[120px]', sortable: true, type: 'date', dateFormat: 'dd/MM/yyyy' },
            { field: 'deadline2', header: 'Deadline 2', width: 'min-w-[120px]', sortable: true, type: 'date', dateFormat: 'dd/MM/yyyy' },
            { field: 'status', header: 'Trạng thái', width: 'min-w-[150px]', sortable: true, type: 'tag', tagType: 'enrolmentStatus' },
            { field: 'availableShifts', header: 'Ca học', width: 'min-w-[150px]', sortable: false, type: 'custom' }
        ],
        features: {
            virtualScroll: true,
            toolbar: true,
            selection: {
                mode: 'single',
                metaKeySelection: false,
                dataKey: 'id',
                onSelect: PLACEHOLDER_FUNCTIONS.ON_SELECT,
                onUnselect: PLACEHOLDER_FUNCTIONS.ON_UNSELECT
            }
        },
        actions: [
            {
                location: 'toolbar',
                useDefaultStyle: 'add',
                permission: PERMISSIONS.ENROLMENT_EDIT.code,
                onClick: PLACEHOLDER_FUNCTIONS.OPEN_NEW
            },
            {
                location: 'row',
                useDefaultStyle: 'edit',
                permission: PERMISSIONS.ENROLMENT_EDIT.code,
                onClick: PLACEHOLDER_FUNCTIONS.EDIT
            }
        ],
        bodyBuilder: (_params, _baseQuery, _externalFilter, internalFilter, _searchTerm) => {
            // internalFilter comes from the filter toolbar and is already in SearchEnrolmentDTO format
            // Just pass it through as the body
            return internalFilter || {};
        }
    };
};

